/* eslint 'array-callback-return': 'off','no-new-object': 'off','no-array-constructor': 'off','no-redeclare': 'off', 'jsx-a11y/anchor-is-valid': 'off'  */
import React, { Component } from 'react';
import { Table, Label } from 'reactstrap';

export default class CustomDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.SelectAllChange = this.SelectAllChange.bind(this);
        this.SelectDDlOption = this.SelectDDlOption.bind(this);
    }  

    SelectAllChange(){
        if(this.refs.chk_Select_All.checked)
            this.props.setValue(-1, 'Select All', false);
        else{
            let FirstZone = (this.props.data !== undefined && this.props.data !== null && this.props.data.length) ? this.props.data[0] : {'zoneId': 0, 'zoneName': ''}
            this.props.setValue(FirstZone.zoneId, FirstZone.zoneName, true);
        }
    }

    SelectDDlOption(el){
        this.refs.chk_Select_All.checked = false;
        this.props.setValue(Number(el.zoneId), el.zoneName);
    }

    render(){
        var data = this.props.data;
        let Zones = [];

        if (data !== undefined && data !== null && data.length) {
            Zones = data.map((el) => {
                return <tr className='Custom_ddl_row' key={el.zoneId} style={{backgroundColor : Number(this.props.SelectedZoneID) === Number(el.zoneId) ? '#007bff' : 'white'}} onClick={() =>{this.SelectDDlOption(el)}}>
                    <td>{el.zoneName}</td>
                </tr>
            })
        }
        else {
            Zones = <tr><td colSpan="3">No Records found</td></tr>
        }

        return(
            <div ref={this.props.refMethod} style={this.props.elementStyle}>
                <Table style={{ bordertop: "0 solid" }}>
                    <tbody>
                        <tr className='Custom_ddl_row'>
                            <th>
                                <Label style={{"width" : "100%", "cursor":"pointer"}}>
                                    <input type="checkbox" ref="chk_Select_All" style={{'vertical-align':'middle', "cursor":"pointer"}} defaultChecked={false} onChange={() =>{this.SelectAllChange()}} /> Select All
                                </Label>
                            </th> 
                        </tr>
                        {Zones}
                    </tbody>
                </Table>
            </div>
        );
    }
}